import {
  UserPreferences,
  UserPreferencesType
} from "seneca-common/features/user/state";

import {
  MAP_GRADIENT_OPTIONS,
  MapGradientOptions,
  TypingOptions,
  typingOptions
} from "../consts/preferences";

export function validateAndFormatMapGradient(
  input: string
): MapGradientOptions {
  return (
    (input && (MAP_GRADIENT_OPTIONS as any)[input]) ||
    MAP_GRADIENT_OPTIONS.SANGUINE
  );
}

export function validateAndFormatTypingOption(input: string): TypingOptions {
  const validPref = !!Object.values(typingOptions).filter(
    pref => pref === input
  )[0];
  // $FlowFixMe - input has been validated
  return validPref ? input : typingOptions.ONE;
}

export function getNonNullPreferences(
  preferences: UserPreferences
): Partial<UserPreferencesType> {
  const nonNullPreferences = preferences
    .toSeq()
    .reduce((nonNullPreferences, preference, key) => {
      if (preference !== null && preference !== undefined) {
        return { ...nonNullPreferences, [key]: preference };
      } else {
        return nonNullPreferences;
      }
    }, {});
  return nonNullPreferences;
}
